<template>
  <div class="page-item user-content" :style="contentStyle">
    <div class="left">
      <img
        :src="imgSrc"
        style="width: 80px; height: 80px; border-radius: 50%;"
      />
      <div class="left-content">
        <div class="left-top">
          <span class="left-top-text1">{{ title }}</span>
        </div>
        <div class="left-center">
          <div class="flex">
            <span
              v-if="
                isIdentity == 'supplier' &&
                  vipInfo.timeInfo &&
                  vipInfo.timeInfo.endTime
              "
            >
              <span v-if="!vipInfo.rightsId" class="btn" @click="memberHandle">
                开通会员
              </span>
              <span v-else>
                <img
                  v-if="
                    vipInfo.productInfo &&
                      vipInfo.productInfo.productCode === 'regular_vip'
                  "
                  :src="basicIcon"
                  class="vip-icon"
                />
                <img
                  v-if="
                    vipInfo.productInfo &&
                      vipInfo.productInfo.productCode === 'advanced_vip'
                  "
                  :src="premiumIcon"
                  class="vip-icon"
                />
                <img
                  v-if="
                    vipInfo.productInfo &&
                      vipInfo.productInfo.productCode === 'diamond_vip'
                  "
                  :src="diamondIcon"
                  class="vip-icon"
                />
              </span>
            </span>
            <we-chat-bind-dialog model="wx-icon" />
          </div>
        </div>
        <div class="left-bottom">
          <div class="serve-box">
            <span class="text1">身份开通：</span>
            <div
              v-for="(item, index) in serveList"
              :key="index"
              class="serve-list"
            >
              <img
                :src="item.openServe ? item.openIcon : item.icon"
                class="icon"
                style="width: 20px; height: 20px;"
              />
              <div
                class="serve-box-text2"
                :class="item.openServe ? 'open-serve-text' : ''"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <template v-if="isIdentity == 'supplier'">
        <template v-if="showPreSave">
          <!-- 保证金预存 -->
          <div v-if="!guaranteePreSave.subAccountNo" class="right-text">
            <img
              class="service-open"
              src="@/assets/images/supplier/guarantee-pre-save/pre-save-open-tip.png"
              @click="openGuaranteePreSave"
            />
          </div>
          <div v-else class="right-content">
            <div class="pre-save-box" @click="openGuaranteePreSave(true)">
              <div class="box-title">
                <img
                  src="@/assets/images/supplier/guarantee-pre-save/service-icon-round.png"
                  alt=""
                />
                <span class="title-main">灵活宝</span>
                <span class="title-second">保证金预存</span>
              </div>
              <div class="box-sub">
                <span>保证金可用额度</span>
                <span>{{ guaranteePreSave.remainTotalAmount }}元</span>
              </div>
            </div>
          </div>
        </template>
        <!-- 会员 -->
        <div v-if="!vipInfo.rightsId" class="right-text">
          <img
            class="service-open"
            src="@/assets/images/value-added/vip-open-tip.png"
            @click="memberHandle"
          />
        </div>
        <div v-else class="right-content">
          <div class="vip-content" :style="benefitsStyle">
            <div class="title-box">
              <span class="font-bold">会员权益</span>
              <span class="font-12">
                到期时间：{{ vipInfo.timeInfo.endTime }}
              </span>
            </div>
            <div class="benefits-content">
              <div
                v-for="(item, index) in benefitsList"
                :key="index"
                class="benefits-content-item"
              >
                <span>
                  <img
                    :src="item.icon"
                    class="m-r-8"
                    style="width: 24px; height: 24px;"
                  />
                  {{ item.label }}
                  (剩余{{ item.remain }})
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { toVipBuy } from '@/utils/platform'
import {
  queryValueAddedServiceAccountBalanceApi,
  getFollowedProjectPageApi,
  getFollowedCompanyPageApi
} from '@/api/value-added-service'
import { valueAddedProductCodeDict } from '@/dictionary/value-added-service'
import { getTimeText } from '@/utils/utils'
import WeChatBindDialog from '@/components/common/WeChatBindDialog'

import { getFileUrlByFileIdApi } from '@/api/up-file'

import { workbenchServiceDict } from '@/dictionary/system'

export default {
  name: 'HomeUser',

  components: {
    WeChatBindDialog
  },

  data() {
    return {
      workbenchServiceDict,

      avatar: require('@/assets/images/home/User/avatar.png'),
      imgSrc: '',
      basicIcon: require('@/assets/images/home/User/basic.png'),
      premiumIcon: require('@/assets/images/home/User/premium.png'),
      diamondIcon: require('@/assets/images/home/User/diamond.png'),
      // 基础会员权益
      basicMemberBenefits: [
        {
          icon: require('@/assets/images/home/User/basic1.png'),
          label: '标书预览',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/basic2.png'),
          label: '标讯订阅',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/basic3.png'),
          label: '画像报告',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/basic4.png'),
          label: '数据导出',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/basic5.png'),
          label: '企业关注',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/basic6.png'),
          label: '项目关注',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/basic7.png'),
          label: 'CA抵扣券',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/basic8.png'),
          label: '在线签章抵扣券',
          remain: 0
        }
      ],
      premiumMemberBenefits: [
        {
          icon: require('@/assets/images/home/User/premium1.png'),
          label: '标书预览',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/premium2.png'),
          label: '标讯订阅',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/premium3.png'),
          label: '画像报告',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/premium4.png'),
          label: '数据导出',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/premium5.png'),
          label: '企业关注',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/premium6.png'),
          label: '项目关注',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/premium7.png'),
          label: 'CA抵扣券',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/premium8.png'),
          label: '在线签章抵扣券',
          remain: 0
        }
      ],
      diamondMemberBenefits: [
        {
          icon: require('@/assets/images/home/User/diamond1.png'),
          label: '标书预览',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/diamond2.png'),
          label: '标讯订阅',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/diamond3.png'),
          label: '画像报告',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/diamond4.png'),
          label: '数据导出',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/diamond5.png'),
          label: '企业关注',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/diamond6.png'),
          label: '项目关注',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/diamond7.png'),
          label: 'CA抵扣券',
          remain: 0
        },
        {
          icon: require('@/assets/images/home/User/diamond8.png'),
          label: '在线签章抵扣券',
          remain: 0
        }
      ],
      benefitsList: [],

      // 是否显示保证金预存信息
      showPreSave: false
    }
  },

  computed: {
    ...mapState('user', ['employeeName', 'face', 'vipInfo']),
    ...mapState('router', ['currentWorkbench']),
    ...mapState('company', [
      'isCertified',
      'isPurchaser',
      'isAgency',
      'isSupplier'
    ]),
    ...mapState('finance', ['guaranteePreSave']),

    // 获取当中工作台身份
    isIdentity() {
      return workbenchServiceDict.translate(this.currentWorkbench)?.alias
    },

    serveList() {
      const arr = [
        {
          label: '采购人',
          openServe: this.isPurchaser,
          openIcon: require('@/assets/images/home/User/purchase-open.png'),
          icon: require('@/assets/images/home/User/purchase.png')
        },
        {
          label: '供应商',
          openServe: this.isSupplier,
          openIcon: require('@/assets/images/home/User/supplier-open.png'),
          icon: require('@/assets/images/home/User/supplier.png')
        },
        {
          label: '代理机构',
          openServe: this.isAgency,
          openIcon: require('@/assets/images/home/User/agency-open.png'),
          icon: require('@/assets/images/home/User/agency.png')
        }
      ]
      return arr
    },
    title() {
      if (this.isIdentity == 'supplier' && !this.vipInfo.rightsId) {
        const timeText = getTimeText()
        return `${timeText}，${this.employeeName}，祝你开心每一天!`
      } else {
        return `${this.employeeName}`
      }
    },
    contentStyle() {
      let styleObj = {}
      if (this.isIdentity == 'supplier') {
        if (!this.vipInfo.rightsId) {
          styleObj = {
            backgroundImage: `url(${require('@/assets/images/home/User/supplier-no-vip-bg.png')})`
          }
        } else {
          if (this.vipInfo.productInfo.productCode === 'regular_vip') {
            styleObj = {
              backgroundImage: `url(${require('@/assets/images/home/User/supplier-basic-vip-bg.png')})`
            }
          }
          if (this.vipInfo.productInfo.productCode === 'advanced_vip') {
            styleObj = {
              backgroundImage: `url(${require('@/assets/images/home/User/supplier-premium-vip-bg.png')})`
            }
          }
          if (this.vipInfo.productInfo.productCode === 'diamond_vip') {
            styleObj = {
              backgroundImage: `url(${require('@/assets/images/home/User/supplier-diamond-vip-bg.png')})`
            }
          }
        }
      }
      return styleObj
    },
    benefitsStyle() {
      let styleObj = {}
      if (
        this.isIdentity == 'supplier' &&
        this.vipInfo.productInfo.productCode === 'regular_vip'
      ) {
        styleObj = {
          // background: '#416BAA',
          // opacity: 0.4,
          background: `rgba(65, 107, 170, 0.4)`
        }
      }
      if (
        this.isIdentity == 'supplier' &&
        this.vipInfo.productInfo.productCode === 'advanced_vip'
      ) {
        styleObj = {
          // background: '#7C5C2F',
          // opacity: 0.4,
          background: `rgba(124, 92, 47, 0.4)`
        }
      }
      if (
        this.isIdentity == 'supplier' &&
        this.vipInfo.productInfo.productCode === 'diamond_vip'
      ) {
        styleObj = {
          // background: '#7663BF',
          // opacity: 0.4,
          background: `rgba(118, 99, 191, 0.4)`
        }
      }
      return styleObj
    }
  },

  watch: {
    isIdentity: {
      handler: function(val) {
        if (val === 'supplier' && this.vipInfo.rightsId) {
          this.getSupplierInfo()
        }
      },
      immediate: true
    },
    face: {
      handler: function(val) {
        if (!val) {
          this.imgSrc = this.avatar
        } else {
          this.getFileUrlByGroupId()
        }
      },
      immediate: true
    }
  },

  created() {
    window.addEventListener('resize', this.onScreenChange)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.onScreenChange)
    })
    this.$store.dispatch('finance/getGuaranteePreSave').then(() => {
      this.onScreenChange()
    })
  },

  methods: {
    onScreenChange() {
      this.showPreSave = window.screen.width >= 1560
    },

    getFileUrlByGroupId() {
      getFileUrlByFileIdApi({ attachmentId: this.face })
        .then(res => {
          this.imgSrc =
            res?.data?.external ||
            require('@/assets/images/home/User/avatar.png')
        })
        .catch(err => {
          this.loadingFail = true
          this.imgSrc = require('@/assets/images/fail-img.png')
        })
    },
    getSupplierInfo() {
      const arr = valueAddedProductCodeDict.array
      arr.map(arrItem => {
        if (arrItem.homeSerch) {
          this.getMemberBenefits(arrItem.value)
        }
      })
      this.getFollowedProjectRemain()
      this.getFollowedCompanyRemain()
    },
    getMemberBenefits(params) {
      if (
        this.isIdentity == 'supplier' &&
        this.vipInfo.productInfo.productCode === 'regular_vip'
      ) {
        this.benefitsList = this.basicMemberBenefits
      }
      if (
        this.isIdentity == 'supplier' &&
        this.vipInfo.productInfo.productCode === 'advanced_vip'
      ) {
        this.benefitsList = this.premiumMemberBenefits
      }
      if (
        this.isIdentity == 'supplier' &&
        this.vipInfo.productInfo.productCode === 'diamond_vip'
      ) {
        this.benefitsList = this.diamondMemberBenefits
      }
      queryValueAddedServiceAccountBalanceApi(params)
        .then(res => {
          // 标书预览余额
          if (params == valueAddedProductCodeDict.BID_FILE_PREVIEW.value) {
            this.benefitsList[0].remain = res.data.remain || 0
          }
          // 标讯订阅余额
          if (params == valueAddedProductCodeDict.MARK_SUBSCRIBE.value) {
            this.benefitsList[1].remain = res.data.remain || 0
          }
          // 企业画像余额
          if (params == valueAddedProductCodeDict.COMPANY_PORTRAIT.value) {
            this.benefitsList[2].remain = res.data.remain || 0
          }
          // 数据导出余额
          if (params == valueAddedProductCodeDict.NOTICE_EXPORT.value) {
            this.benefitsList[3].remain = res.data.remain || 0
          }
          // CA抵扣券余额
          if (
            params ==
            valueAddedProductCodeDict.DIGITAL_CERTIFICATE_VOUCHER.value
          ) {
            this.benefitsList[6].remain = res.data.remain || 0
          }
          // 在线签章抵扣券余额
          if (params == valueAddedProductCodeDict.ESIGN_VOUCHER.value) {
            this.benefitsList[7].remain = res.data.remain || 0
          }
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },
    getFollowedProjectRemain() {
      const params = {
        page: 1,
        size: 10
      }
      getFollowedProjectPageApi(params)
        .then(res => {
          this.benefitsList[5].remain = 100 - res.data.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },
    getFollowedCompanyRemain() {
      const params = {
        page: 1,
        size: 10
      }
      getFollowedCompanyPageApi(params)
        .then(res => {
          this.benefitsList[4].remain = 100 - res.data.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },
    memberHandle() {
      toVipBuy()
    },

    openGuaranteePreSave(hasAccount = false) {
      this.$router.push({
        name: hasAccount ? 'GuaranteePreSave' : 'GuaranteePreSaveOpen'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 128px;
  margin: 16px 8px 8px 8px;
  box-sizing: border-box;
  border-radius: 4px;
}
.user-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    height: 100%;
    padding: 18px 12px 18px 24px;
    .left-content {
      margin-left: 24px;
      height: 100%;
      .left-top {
        display: flex;
        .left-top-text1 {
          font-size: 24px;
          @include text-bold;
          color: $text-color;
        }
      }
      .left-center {
        font-size: 14px;
        margin-top: 12px;
        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 20px;
          width: 100px;
          background: $warning-second-color;
          font-size: 12px;
          cursor: pointer;
          color: $text-color;
          border-radius: 4px;
        }
        .text {
          font-size: 14px;
          color: $third-text-color;
        }
      }
      .left-bottom {
        display: flex;
        align-items: center;
        margin-top: 12px;
        .serve-box {
          display: flex;
          align-items: center;
        }
        .text1 {
          font-size: 14px;
          color: $third-text-color;
          white-space: nowrap;
        }
        .serve-list {
          display: flex;
          align-items: center;
          margin-left: 20px;
          .icon {
            margin-top: -3px;
          }
        }
        .serve-box-text2 {
          white-space: nowrap;
          font-size: 14px;
          color: $second-text-color;
          margin-left: 5px;
        }
        .open-serve-text {
          color: $primary-color;
        }
        .text2 {
          font-size: 14px;
          color: $text-color;
        }
        .text3 {
          font-size: 14px;
          color: $primary-color;
          margin-left: 16px;
        }
        .ca-box {
          display: flex;
        }
      }
    }
    .vip-icon {
      width: 94px;
      height: 28px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    height: 100%;
    .right-content {
      height: 100%;
      padding: 8px 8px 8px 0;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .vip-content {
        max-width: 860px;
        min-width: 740px;
        height: 100%;
        border-radius: 50px 4px 4px 4px;

        .title-box {
          display: flex;
          justify-content: space-between;
          color: $white-color;
          margin: 0 16px 0 24px;
          padding-top: 12px;
        }
        .benefits-content {
          display: flex;
          margin-left: 20px;
          margin-top: 4px;
          flex-wrap: wrap;
          .benefits-content-item {
            min-width: 173px;
            width: 25%;
            margin-top: 10px;
            color: $white-color;
          }
        }
      }
    }
  }
  .right-text {
    font-size: 16px;
    height: 100%;
    padding-right: 24px;
    @include text-bold;
    color: $text-color;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 16px;
      background: $warning-second-color;
      font-size: 14px;
      margin-left: 24px;
      cursor: pointer;
      color: $text-color;
      border-radius: 4px;
    }
  }
}
.status-primary {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: $primary-color;
  border-radius: 50%;
  content: ' ';
}

.service-open {
  height: 100px;
  cursor: pointer;
}

.pre-save-box {
  background: url('~@/assets/images/supplier/guarantee-pre-save/service-icon-card.png')
    no-repeat;
  background-size: cover;
  color: $deep-primary-color;
  width: 240px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  cursor: pointer;

  .box-title {
    width: 100%;
    display: flex;
    align-items: center;
    color: $white-color;

    img {
      width: 40px;
      margin-right: 10px;
    }

    .title-main {
      font-size: 20px;
      margin-right: 10px;
    }
  }

  .box-sub {
    width: 100%;
    height: 32px;
    background: rgba(255, 255, 255, 0.67);
    border-radius: 4px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
